(function () {
  var root = document.querySelector('[data-astra-faq]');
  if (!root) return;

  var buttons = root.querySelectorAll('[data-faq-filter]');
  var items = root.querySelectorAll('[data-faq-category]');
  var empty = root.querySelector('[data-faq-empty]');

  function filter(category) {
    var visible = 0;
    items.forEach(function (item) {
      var show = category === 'all' ? item.hasAttribute('data-faq-all') : item.getAttribute('data-faq-category') === category;
      item.hidden = !show;
      if (show) visible += 1;
    });
    if (empty) empty.hidden = visible > 0;
    buttons.forEach(function (button) {
      var active = button.getAttribute('data-faq-filter') === category;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      filter(button.getAttribute('data-faq-filter') || 'all');
    });
  });
})();
